import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../lib/theme";

export default function Footer() {
  return (
    <footer style={{
      maxWidth: 1100, margin: "40px auto 0", padding: "16px 28px",
      borderTop: `1px solid ${colors.line}`, display: "flex", justifyContent: "space-between",
      alignItems: "center", flexWrap: "wrap", gap: 10,
    }}>
      <span style={{ fontSize: 12, color: colors.textFaint }}>
        © {new Date().getFullYear()} Intec Engineering Solutions, S.L. · info@centineldx.com
      </span>
      <Link to="/aviso-legal" style={{ fontSize: 12, color: colors.textFaint, textDecoration: "none" }}>
        Aviso legal
      </Link>
    </footer>
  );
}
